import { useMemo } from "react";
import api from "../services/apiService";
import { useAuth } from "../auth/ProvideAuth";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

const AxiosProvider = ({ children }) => {
    const auth = useAuth();
    const history = useHistory();

    const logout = () => {
        auth.signout(() => {
            toast.warn(
                "Credenciais expiradas ou inválidas.\nEfetue login novamente para continuar.",
                {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    className: "toast-neocredit",
                    progressClassName: "progress-toast-neocredit",
                }
            );
        });
    };

    useMemo(() => {
        api.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error && error.response && error.response.data) {
                    if (
                        error.response.status == 403 ||
                        error.response.status == 401
                    ) {
                        logout();
                    }
                    return Promise.reject(error.response.data);
                }
                return Promise.reject(error.message);
            }
        );
    }, []);

    return children;
};

export default AxiosProvider;
